var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSelectFile = function SvgSelectFile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#selectFile_svg__a)",
    stroke: "#1A1E2C",
    strokeWidth: 0.75
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 4H7a1 1 0 0 0-1 1v15a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1V9.312"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 4v5h5l-5-5Z",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 13.625h7M9 16.625h7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "selectFile_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgSelectFile;